import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToggle } from "react-use";
import * as yup from "yup";
import { obterValidador, VALIDADOR_TIPO } from "../../../../utils";
import { Stack } from "@mui/material";
import { EntradaForm, H6 } from "../../../../components";
import { usersPageAddEdit } from "../reducers/users-page-actions";
import { seletorMenu, seletorStore } from "../users-selectors";

const STR = {
  titleAdd: "Adicionar novo usuário",
  titleEdit: "Editar usuário",
  labelName: "Nome",
  labelEmail: "E-mail",
  labelPassword: "Senha",
  labelStatus: "Usuário Ativo ?",
  placeholderName: "Digite o nome",
  placeholderEmail: "Digite o e-mail",
  placeholderPassword: "Digite a senha",
  errorName: "* O nome deve conter ao menos 3 caracteres",
  errorEmail: "* E-mail inválido",
  errorPassword: "* A senha deve conter ao menos 6 caracteres",
  errorStatus: "* Selecione o status",
  placeholderStore: "Informe as lojas de acesso do usuário",
  errorStore: "* Escolha ao menos uma loja",
  placeholderMenu: "Informe os menus de acesso do usuário",
  errorMenu: "* Escolha ao menos um menu",
  labelMenu: "Menu",
  labelStore: "Loja",
};

const KEYS = {
  name: "nome",
  email: "email",
  password: "senha",
  status: "status",
  stores: "lojas",
  menus: "menus",
};

function UsersPageAddEditUser({ id, name, status, email }) {
  const [wait, setWait] = useToggle();
  const dispatch = useDispatch();
  const stores = useSelector(seletorStore);
  const menus = useSelector(seletorMenu);
  //
  let schemaMessageError = {
    [KEYS.name]: STR.errorName,
    [KEYS.email]: STR.errorEmail,
  };
  let schemaValidator = {
    [KEYS.name]: obterValidador(VALIDADOR_TIPO.texto, 3),
    [KEYS.email]: yup.string().email().required(),
  };

  //
  const schema = [
    {
      type: "text",
      name: KEYS.name,
      label: STR.labelName,
      placeholder: STR.placeholderName,
      defaultValue: name,
    },
    {
      type: "email",
      name: KEYS.email,
      label: STR.labelEmail,
      placeholder: STR.placeholderEmail,
      defaultValue: email,
      disabled: !!id,
    },
  ];
  if (!id) {
    schema.push({
      type: "password",
      name: KEYS.password,
      label: STR.labelPassword,
      placeholder: STR.placeholderPassword,
      defaultValue: "",
    });
    //
    schema.push({
      type: "select",
      name: KEYS.stores,
      label: STR.labelStore,
      placeholder: STR.placeholderStore,
      itens: stores,
      isMulti: true,
      autoFormat: true,
    });
    //
    schema.push({
      type: "select",
      name: KEYS.menus,
      label: STR.labelMenu,
      placeholder: STR.placeholderMenu,
      itens: menus,
      isMulti: true,
      autoFormat: true,
    });
    schemaMessageError[KEYS.stores] = STR.errorStore;
    schemaMessageError[KEYS.password] = STR.errorPassword;
    schemaMessageError[KEYS.status] = STR.errorStatus;
    schemaValidator[KEYS.password] = obterValidador(VALIDADOR_TIPO.texto, 6);
    schemaValidator[KEYS.stores] = obterValidador(
      VALIDADOR_TIPO.selectMultiplo
    );
    schemaValidator[KEYS.menus] = obterValidador(VALIDADOR_TIPO.selectMultiplo);
  } else {
    schema.push({
      type: "switch",
      name: KEYS.status,
      label: STR.labelStatus,
      defaultChecked: status === "A",
    });
  }

  //
  schemaValidator = yup.object().shape(schemaValidator);
  //
  const onSubmit = useCallback(
    (val) => {
      const obj = {
        nome: val[KEYS.name],
        email: val[KEYS.email],
        senha: val[KEYS.password],
        status: "A",
        lojas: val[KEYS.stores]
          ? val[KEYS.stores].map((ele) => ele.value)
          : null,
        menus: val[KEYS.menus] ? val[KEYS.menus].map((ele) => ele.value) : null,
      };
      if (id) {
        obj.id = id;
        obj.status = val[KEYS.status] ? "A" : "B";
        delete obj.email;
        delete obj.senha;
        delete obj.lojas;
        delete obj.menus;
      }

      dispatch(usersPageAddEdit(obj, setWait));
    },
    [dispatch, id, setWait]
  );
  return (
    <Stack>
      <H6>{STR.titleAdd}</H6>
      <EntradaForm
        schema={schema}
        schemaValidator={schemaValidator}
        schemaMessageError={schemaMessageError}
        onSubmit={onSubmit}
        wait={wait}
      />
    </Stack>
  );
}

export default UsersPageAddEditUser;
